import { useInject } from '@actr/di';
import { useNavigation } from '@actr/hooks';
import { AuthStore } from '@actr/stores/src/stores/stores/account/auth/auth';
import { AppStore } from '@actr/stores/src/stores/stores/common/app';
import { Sizes } from '@actr/style';
import { Button, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { FlexWrapper } from '@actr/ui/src/components/_atoms/flex-wrapper';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import FindMyOrderForm from '@actr/widgets/src/components/_misc/layouts/header/find-my-order-form';
import { AccountRoutes } from '@actr/widgets/src/navigation/routes/account';
import React, { FC, useCallback } from 'react';

import * as Styled from './style.css';

const AccountFeatures: FC = () => {

  const { navigate } = useNavigation();
  const { setShowFeedbackModal } = useInject(AppStore);
  const auth = useInject(AuthStore);
  const toAccount = useCallback(() => {
    if (auth.isAuthorized) {
      navigate(AccountRoutes.ORDERS, { useRouter: false });
    } else {
      auth.login.setModalFormOpened(true);
    }
  }, [navigate]);

  const toFaq = useCallback(() => {
    navigate('/usefuldata/faq', { useRouter: false });
  }, [navigate]);

  const handleOpenFeedbackForm = useCallback(() => {
    setShowFeedbackModal(true);
  }, [setShowFeedbackModal]);

  return (
    <FlexWrapper gap={Sizes.S} wrap>
      <ContentBlock className={Styled.ContentBlock}>
        <FindMyOrderForm withCabinetButton={false} title="Где мой заказ" />
      </ContentBlock>
      <ContentBlock className={Styled.ContentBlock}>
        <Text className={Styled.Title} font="paragraph.m.semi">Дополнительные услуги</Text>
        <Text className={Styled.Info} font="paragraph.s">
          Вы можете добавить дополнительные услуги к вашему заказу в личном кабинете
        </Text>
        <Button
          className={Styled.AccountButton}
          buttonType={ButtonTypes.PRIMARY}
          onClick={toAccount}
          fullWidth>
          Перейти в личный кабинет
        </Button>
      </ContentBlock>
      <ContentBlock className={Styled.ContentBlock}>
        <Text className={Styled.Title} font="paragraph.m.semi">Поддержка</Text>
        <Text className={Styled.Info} font="paragraph.s">
          Напишите нам, если у вас есть вопросы по заказу или найдите ответ самостоятельно
        </Text>
        <FlexWrapper gap={Sizes.XS}>
          <Button
            className={Styled.AccountButton}
            buttonType={ButtonTypes.SECONDARY}
            onClick={toFaq}
            fullWidth>
            Почитать
          </Button>
          <Button
            className={Styled.AccountButton}
            buttonType={ButtonTypes.PRIMARY}
            onClick={handleOpenFeedbackForm}
            fullWidth>
            Написать
          </Button>
        </FlexWrapper>
      </ContentBlock>
    </FlexWrapper>
  );
};

export default AccountFeatures;
